import { Pipe } from '@angular/core';

@Pipe({
  name: "asArray"
})
export class AsArrayPipe {
	transform(array: any): Array<any> {		
		return array as Array<any>;
	}
}